<section class="event-section bg-gray-100 py-5">
    <div class="container">
        <div class="section-title text-center mb-5">
            <h2 class="mb-3">Our Events</h2>
            <p class="lead">
                Stay updated with our latest events, conferences, and industry
                meetups.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="event-content">
                    <div class="event-item mb-5">
                        <div class="row align-items-center">
                            <div class="col-md-6">
                                <div class="event-image">
                                    <img
                                        src="assets/img/event/event1.png"
                                        alt="Tech Conference 2025"
                                        class="img-fluid rounded shadow"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="event-details">
                                    <span
                                        class="event-date badge bg-primary mb-2"
                                        >Sept 09, 2025</span
                                    >
                                    <h3 class="event-title">
                                        Tech Conference 2025
                                    </h3>
                                    <p class="event-description">
                                        Join us for our annual technology
                                        conference where industry leaders will
                                        discuss the latest trends in cloud
                                        computing, cybersecurity, and digital
                                        transformation.
                                    </p>
                                    <ul class="event-info list-unstyled">
                                        <li>
                                            <i class="bx bx-time"></i> 9:00 AM -
                                            5:00 PM
                                        </li>
                                        <li>
                                            <i class="bx bx-map"></i> Mumbai,
                                            India
                                        </li>
                                        <li>
                                            <i class="bx bx-user"></i> Open to
                                            all IT professionals
                                        </li>
                                    </ul>
                                    <a href="#" class="btn btn-primary"
                                        >Register Now</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="event-item mb-5">
                        <div class="row align-items-center">
                            <div class="col-md-6 order-md-2">
                                <div class="event-image">
                                    <img
                                        src="assets/img/event/event2.png"
                                        alt="Cloud Security Workshop"
                                        class="img-fluid rounded shadow"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 order-md-1">
                                <div class="event-details">
                                    <span
                                        class="event-date badge bg-success mb-2"
                                        >April 22, 2025</span
                                    >
                                    <h3 class="event-title">
                                        Cloud Security Workshop
                                    </h3>
                                    <p class="event-description">
                                        Learn best practices for securing your
                                        cloud infrastructure with our hands-on
                                        workshop. Expert trainers will guide you
                                        through real-world scenarios.
                                    </p>
                                    <ul class="event-info list-unstyled">
                                        <li>
                                            <i class="bx bx-time"></i> 10:00 AM
                                            - 4:00 PM
                                        </li>
                                        <li>
                                            <i class="bx bx-map"></i> Bangalore,
                                            India
                                        </li>
                                        <li>
                                            <i class="bx bx-user"></i> IT
                                            Security Professionals
                                        </li>
                                    </ul>
                                    <a href="#" class="btn btn-primary"
                                        >Register Now</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="event-item">
                        <div class="row align-items-center">
                            <div class="col-md-6">
                                <div class="event-image">
                                    <img
                                        src="assets/img/event/event3.png"
                                        alt="DevOps Meetup"
                                        class="img-fluid rounded shadow"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="event-details">
                                    <span
                                        class="event-date badge bg-warning mb-2"
                                        >Jan 20, 2024</span
                                    >
                                    <h3 class="event-title">DevOps Meetup</h3>
                                    <p class="event-description">
                                        Connect with fellow DevOps practitioners
                                        and learn about the latest tools and
                                        methodologies to streamline your
                                        development processes.
                                    </p>
                                    <ul class="event-info list-unstyled">
                                        <li>
                                            <i class="bx bx-time"></i> 6:00 PM -
                                            9:00 PM
                                        </li>
                                        <li>
                                            <i class="bx bx-map"></i> Delhi,
                                            India
                                        </li>
                                        <li>
                                            <i class="bx bx-user"></i> DevOps
                                            Engineers & Developers
                                        </li>
                                    </ul>
                                    <a href="#" class="btn btn-primary"
                                        >Register Now</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
